/* Top-Bar: Restbetrag bis versandkostenfrei nach jeder Warenkorb-Änderung aktualisieren (snippets/versand-info.liquid). */
(function () {
  const bars = () => document.querySelectorAll('[data-versand-bar]');
  const money = (cents) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);

  function render(cart) {
    bars().forEach((bar) => {
      const free = parseInt(bar.dataset.freeCents, 10);
      if (!cart || !cart.item_count) {
        bar.innerHTML = bar.dataset.empty;
      } else if (cart.total_price >= free) {
        bar.innerHTML = 'dein versand ist kostenlos <span class="versand-info__heart" aria-hidden="true">♥</span>';
      } else {
        bar.innerHTML =
          'noch ' + money(free - cart.total_price) +
          ' bis <span class="small-hide">versandkostenfrei</span><span class="medium-hide large-up-hide">versandfrei</span> ♡';
      }
    });
    if (window.versandTag) window.versandTag.setCart(cart);
  }

  function refresh() {
    if (!bars().length && !document.querySelector('[data-versand-tag]')) return;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then(render)
      .catch(() => {});
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refresh();
  });
})();

/* Warenkorb nur als Seitenleiste: /cart öffnet die Leiste über der vorherigen Seite,
   Ergänzungen werden direkt in der Leiste hinzugefügt. */
(function () {
  const drawer = () => document.querySelector('cart-drawer');
  const path = window.location.pathname.replace(/\/$/, '');

  if (path.endsWith('/cart') && drawer()) {
    let target = '/';
    try {
      const ref = new URL(document.referrer);
      if (ref.host === window.location.host && !ref.pathname.replace(/\/$/, '').endsWith('/cart')) target = ref.pathname + ref.search;
    } catch (error) {}
    window.location.replace(target + (target.includes('?') ? '&' : '?') + 'warenkorb=offen');
    return;
  }

  const params = new URLSearchParams(window.location.search);
  if (params.get('warenkorb') === 'offen') {
    params.delete('warenkorb');
    const query = params.toString();
    window.history.replaceState(null, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
    customElements.whenDefined('cart-drawer').then(() => setTimeout(() => drawer() && drawer().open(), 50));
  }

  // Größenwahl der Ergänzung ist keine Mengenänderung: Dawns Warenkorb (cart-drawer-items) prüft sonst jede
  // Änderung im Scrollbereich als Mengenfeld und meldet "nur in Abstufungen von ... hinzufügen".
  document.addEventListener(
    'change',
    (event) => {
      if (event.target.closest && event.target.closest('.versand-info--upsell')) event.stopPropagation();
    },
    true,
  );

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.versand-info__upsell-item');
    const cartDrawer = drawer();
    if (!form || !cartDrawer || !form.closest('cart-drawer')) return;
    event.preventDefault();
    const body = new FormData(form);
    body.delete('return_to');
    body.append('sections', 'cart-drawer,cart-icon-bubble');
    body.append('sections_url', window.location.pathname);
    const button = form.querySelector('button[type=submit]');
    if (button) button.setAttribute('aria-busy', 'true');
    fetch(form.action, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body })
      .then((response) => response.json())
      .then((state) => {
        if (state.status) return form.submit();
        cartDrawer.renderContents(state);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          // Quelle 'cart-items': die Leiste ist schon frisch gerendert, Dawn soll sie nicht ein zweites Mal laden
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state });
        }
      })
      .catch(() => form.submit());
  });
})();

/* Animationen in der Warenkorb-Leiste: Versand-Balken füllt sich beim Öffnen und bei Änderungen,
   Gratisversand erreicht = Balken pink + Herz, neu hinzugefügte Artikel gleiten von unten herein.
   Bei "Bewegung reduzieren" nur die Endzustände. */
(function () {
  const drawerEl = document.querySelector('cart-drawer');
  if (!drawerEl) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const STORE = 'versand-progress';
  const readLines = () => {
    const map = new Map();
    drawerEl.querySelectorAll('.cart-item[data-line-key]').forEach((row) => map.set(row.dataset.lineKey, Number(row.dataset.lineQty)));
    return map;
  };
  let lines = readLines();
  let wasActive = drawerEl.classList.contains('active');
  let pending = false;
  let opening = false;
  const added = new Map();
  const OPEN_DELAY = 220; // Leiste gleitet erst herein (Dawn: 200 ms), dann bewegt sich der Inhalt
  const ITEM_MS = 450;

  function animate() {
    pending = false;
    const justOpened = opening;
    opening = false;
    if (!drawerEl.classList.contains('active')) return;

    const current = readLines();
    const now = performance.now();
    current.forEach((qty, key) => {
      if (!lines.has(key) || qty > lines.get(key)) added.set(key, now + (justOpened ? OPEN_DELAY : 0));
    });
    if (!reduce) {
      // neu oder mehr Stück: dieser Artikel gleitet herein. Rendert Dawn die Liste kurz danach neu,
      // läuft die Bewegung mit negativer Verzögerung an derselben Stelle weiter statt neu zu starten.
      added.forEach((start, key) => {
        const elapsed = now - start;
        if (elapsed > ITEM_MS) return added.delete(key);
        const row = [...drawerEl.querySelectorAll('.cart-item[data-line-key]')].find((r) => r.dataset.lineKey === key);
        if (!row || row.classList.contains('is-added')) return;
        row.style.animationDelay = -elapsed + 'ms';
        row.classList.add('is-added');
      });
    }
    lines = current;

    const box = drawerEl.querySelector('.drawer__inner > .versand-info--cart');
    const fill = box && box.querySelector('.versand-info__bar span');
    if (!fill) return;
    const target = parseFloat(fill.style.width) || 0;
    const previous = Math.min(parseFloat(sessionStorage.getItem(STORE) || '0') || 0, 100);
    sessionStorage.setItem(STORE, String(target));
    const free = box.classList.contains('versand-info--free');
    const celebrate = free && previous < 100;
    if (reduce) return;
    const from = justOpened ? 0 : Math.min(previous, target);
    if (from === target && !justOpened) return;

    box.classList.remove('is-filling', 'is-celebrating', 'is-free-static');
    if (free) box.classList.add(celebrate ? 'is-filling' : 'is-free-static');
    fill.style.transition = 'none';
    fill.style.width = from + '%';
    fill.getBoundingClientRect();
    fill.style.transition = '';
    fill.style.transitionDelay = justOpened ? OPEN_DELAY + 'ms' : '';
    requestAnimationFrame(() => {
      fill.style.width = target + '%';
    });
    if (celebrate) {
      fill.addEventListener('transitionend', function done(event) {
        if (event.propertyName !== 'width') return;
        fill.removeEventListener('transitionend', done);
        box.classList.remove('is-filling');
        box.classList.add('is-celebrating');
      });
    }
  }

  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => requestAnimationFrame(animate));
  };

  new MutationObserver(() => {
    const active = drawerEl.classList.contains('active');
    if (active && !wasActive) {
      opening = true;
      schedule();
    }
    wasActive = active;
  }).observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
  new MutationObserver(schedule).observe(drawerEl, { childList: true, subtree: true });
})();

/* Versandschild auf der Produktseite (snippets/versand-info.liquid, place: 'tag'): bezogen auf diesen Artikel.
   Leerer Warenkorb = klassisch, sonst "Mit diesem Artikel noch X €" oder "versandkostenfrei",
   Warenkorb schon über der Grenze = "Dein Versand ist kostenlos". Dazu: Link "Größentabelle" öffnet die Sized-App. */
(function () {
  const tag = document.querySelector('[data-versand-tag]');
  if (tag && tag.dataset.country !== 'AT') {
    const money = (cents) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    const state = {
      price: Number(tag.dataset.price) || 0,
      total: Number(tag.dataset.cartTotal) || 0,
      count: Number(tag.dataset.cartCount) || 0,
    };
    const free = Number(tag.dataset.freeCents) || 7500;
    const quantity = () => {
      const input = document.querySelector('.product__info-container .kr-buyrow .quantity__input');
      return Math.max(1, Number(input && input.value) || 1);
    };
    const line = (icon, heart, strong, small) =>
      '<span class="versand-info__tag-icon' + (heart ? ' versand-info__heart' : '') + '" aria-hidden="true">' + icon + '</span>' +
      '<span class="versand-info__tag-text"><strong>' + strong + '</strong><small>' + small + '</small></span>';
    const update = () => {
      const after = state.total + state.price * quantity();
      let html;
      if (state.total >= free) html = line('♥', true, 'Dein Versand ist kostenlos', 'dein Warenkorb liegt über ' + tag.dataset.freeFrom + ' €');
      else if (after >= free) html = line('♥', true, 'Mit diesem Artikel versandkostenfrei', 'du sparst ' + tag.dataset.dePrice + ' Versand');
      else if (state.count > 0) html = line('♡', false, 'Mit diesem Artikel noch ' + money(free - after), 'bis zum kostenlosen Versand');
      else html = line('♡', false, 'Versandkostenfrei ab ' + tag.dataset.freeFrom + ' €', 'sonst ' + tag.dataset.dePrice);
      if (tag.innerHTML !== html) tag.innerHTML = html;
    };
    window.versandTag = {
      setCart(cart) {
        if (!cart) return;
        state.total = cart.total_price || 0;
        state.count = cart.item_count || 0;
        update();
      },
    };
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const variant = event && event.data && event.data.variant;
        if (variant && typeof variant.price === 'number') {
          state.price = variant.price;
          update();
        }
      });
    }
    document.addEventListener('change', (event) => {
      if (event.target.closest && event.target.closest('.kr-buyrow .quantity')) update();
    });
    document.addEventListener('click', (event) => {
      if (event.target.closest && event.target.closest('.kr-buyrow .quantity__button')) setTimeout(update, 0);
    });
  }

  // Größentabelle: der Knopf der Sized-App ist versteckt, der Link in der Zeile "Größe" löst ihn aus
  const opener = () => document.querySelector('.product__info-container .sizechart-container .open-sizechart, .product__info-container .storefront-sizechart-open');
  const showLinks = () => {
    const found = opener();
    document.querySelectorAll('[data-kr-sizechart]').forEach((link) => { link.hidden = !found; });
    return found;
  };
  if (document.querySelector('[data-kr-sizechart]')) {
    if (!showLinks()) {
      // Sized lädt nach: kurz beobachten, dann aufgeben
      const observer = new MutationObserver(() => { if (showLinks()) observer.disconnect(); });
      observer.observe(document.querySelector('.product__info-container') || document.body, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 8000);
    }
    document.addEventListener('click', (event) => {
      const link = event.target.closest && event.target.closest('[data-kr-sizechart]');
      if (!link) return;
      const target = opener();
      if (target) target.click();
    });
    // Dawn ersetzt die Auswahl beim Variantenwechsel: Link danach wieder einblenden
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(showLinks, 0));
    }
  }
})();
